<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'article-page',
    data () {
      return {
      }
    },
    created () {
      this.article = false
      this.$http.get(this.$store.state.dataUrlArticle).then(function (response) {
        this.article = response.body
        // TODO: This part should be removed after services implementation - optimized_urls is missed in article.json example
        for (var i = 0; i < this.article.files.figures.length; i++) {
          this.article.files.figures[i].optimized_urls = {}
          this.article.files.figures[i].optimized_urls['small'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/' + this.article.files.figures[i].optimized_file
          this.article.files.figures[i].optimized_urls['hero'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/' + this.article.files.figures[i].optimized_file
        }
        this.$children[0].article = Object.assign({}, this.article)
        this.$root.$emit('changeBreadCrumbs',
          [
            {
              text: this.article.current ? 'Current Issue' : 'Archived Issues',
              name: this.article.current ? 'issueDetail' : 'archivedIssues',
              params: this.article.current ? {
                volumeId: this.article.volume,
                issueId: this.article.issue
              } : {}
            },
            {
              text: 'Volume ' + this.article.volume + ', Number ' + this.article.issue,
              name: 'issueDetail',
              params: {
                volumeId: this.article.volume,
                issueId: this.article.issue
              }
            },
            {
              text: this.article.article_type.name,
              name: 'issueDetail',
              hash: '#' + this.article.article_type.nlm_type,
              params: {
                volumeId: this.article.volume,
                issueId: this.article.issue
              }
            }
          ]
        )
      })
    }
  }
</script>



// WEBPACK FOOTER //
// ArticlePage.vue?3ebf0620